import { useRootStore } from '../RootStateContext';

export const usePdfStore = () => {
  const rootStore = useRootStore();

  if (!rootStore?.pdfStore) {
    throw new Error('pdfStore store should be defined');
  }

  return rootStore.pdfStore;
};
